import { render, staticRenderFns } from "./TheNotification.vue?vue&type=template&id=0c0993bb"
import script from "./TheNotification.vue?vue&type=script&lang=js"
export * from "./TheNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports